// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hV","cusMtdicon":"hV"};